<div class="start-target-values">
  @if (!isKioskMode()) {
    <div class="flex value value-start gap-3">
      @if (!isMobileMode()) {
        <label>
          {{ translation.wayfinding.start | transloco }}
        </label>
      }
      <button
        class="start-target-input grow"
        data-cy="navigation-start-input"
        (click)="wantChangeStartOrTarget.emit(navigationStateEnum.StartSelection)"
        [class.highlighted]="highlightStartSelection()"
        [class.error]="startInputError()"
      >
        <span class="value-wrapper" data-cy="start-basic-input">
          <cue-icon [icon]="ICONS.cueStart" />
          <span [class.placeholder]="startName() === ''" data-cy="start-basic-input">
            {{ startName() || (translation.wayfinding.selectStartLocation | transloco) }}
          </span>
        </span>
        @if (!isKioskMode()) {
          @if (startName() !== '') {
            <cue-icon (click)="deleteStart($event)" [icon]="ICONS.cueClose" class="close-search" />
          } @else {
            <cue-icon [icon]="ICONS.cueEdit" />
          }
        }
      </button>

      @if (!isKioskMode() && responsiveService.isNavigationMobileMode()) {
        <button (click)="scanStartSelection.emit()" class="primary scan-btn" type="button">
          <cue-icon [icon]="ICONS.cueQrCode" />
        </button>
      }
    </div>
  }
  @if (!isKioskMode()) {
    <div class="value-dots">
      <div class="dots" [class.error]="routeConnectorError()">
        <span></span>
        <span></span>
      </div>
      <div
        class="z-[9] text-[--text-danger] px-3 flex items-center gap-2 icon-wrapper"
        style="--cue-icon-color: var(--text-danger)"
      >
        @if (routeErrorMessage()) {
          <cue-icon class="scale-90" [icon]="ICONS.cueWarning" />
        }
        <span class="leading-[0] text-sm">{{ routeErrorMessage() | transloco }}</span>
      </div>
    </div>
  }
  <div
    class="value value-target"
    data-cy="navigation-target-input"
    (click)="wantChangeStartOrTarget.emit(navigationStateEnum.TargetSelection)"
  >
    @if (!isMobileMode()) {
      <label>
        {{ translation.wayfinding.target | transloco }}
      </label>
    }
    <div class="start-target-input" [class.highlighted]="highlightTargetSelection()" [class.error]="targetInputError()">
      <span class="value-wrapper" data-cy="target-basic-input">
        <cue-icon [icon]="ICONS.cueTarget" />
        <span [class.placeholder]="targetName() === ''" data-cy="target-basic-input">
          {{ targetName() || (translation.wayfinding.selectTargetLocation | transloco) }}
        </span>
      </span>
      @if (targetName() !== '') {
        <cue-icon (click)="deleteTarget($event)" [icon]="ICONS.cueClose" class="close-search" />
      } @else {
        <cue-icon [icon]="ICONS.cueEdit" />
      }
    </div>
  </div>
</div>
